exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dv-dokumentupload{margin-bottom:40px}.dv-dokumentupload__link,.dv-dokumentupload__link:focus,.dv-dokumentupload__link:hover{text-decoration:none}.dv-dokumentupload__thumbs{display:flex}.dv-dokumentupload__thumbelement{border:none;margin-right:30px;height:190px}.dv-dokumentupload__thumbcontent{width:150px;overflow:hidden}.dv-dokumentupload__thumbimage{position:relative;height:150px}.dv-dokumentupload__thumbnoimage{position:relative;height:150px;left:25%;margin-left:-15%}.dv-dokumentupload__thumbfilename{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.dv-dokumentupload__thumbfilesize{float:left}.dv-dokumentupload__thumbdelete{float:right}.dv-dokumentupload .dv-dokumentalert{border-top-width:1px;margin-top:10px;margin-left:-10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/core/component/dv-dokumentupload/dv-dokumentupload.scss
// module id = 6Ppe
// module chunks = 0